import type { OrderSummaryPageStore } from '../types';

export class OrderSummaryVisibilityService {
  constructor(private pageStore: OrderSummaryPageStore) {}

  public api() {
    return {
      disable: () => this.pageStore.setState({ orderSummaryDisabled: true }),
      enable: () => this.pageStore.setState({ orderSummaryDisabled: false }),
    };
  }
}
